import { useState, useEffect } from "react";
import { Dialog } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import I18n from "common/i18n";
import { btnDelay, useScale } from "common/utils";
import { CloseBtn, FadeTransition } from "common/elements";

export const DeleteMessageBox = (props: {
  zIndex?: number;
  visible: boolean;
  title: string;
  message: string;
  close: () => void;
  handleDelete: () => void;
}) => {
  const { scale } = useScale();
  const [disabled, setDisabled] = useState(false);
  const { zIndex, title, visible, message, close, handleDelete } = props;

  const handleClose = () => {
    setDisabled(true);
    btnDelay(() => close());
  };

  const handleClick = () => {
    if (!disabled) {
      setDisabled(true);
      handleDelete();
    }
  };

  useEffect(() => {
    if (visible) {
      setDisabled(false);
    }
  }, [visible]);

  return (
    <Dialog
      open={visible}
      maxWidth={false}
      sx={{ zIndex: zIndex ?? 9999 }}
      TransitionComponent={FadeTransition}
      componentsProps={{
        backdrop: { style: { backgroundColor: "transparent" } },
      }}
      PaperProps={{
        style: {
          margin: 0,
          overflow: "visible",
          backgroundColor: "transparent",
        },
        elevation: 0,
      }}
    >
      <div
        className="flex-col-el flex-center relative"
        style={{
          transform: `scale(${scale})`,
        }}
      >
        <div
          className="flex-col-el flex-center relative"
          style={{
            filter:
              "drop-shadow(0px 6px 6px rgb(0 0 0 / 20%)) drop-shadow(0px 10px 14px rgb(0 0 0 / 14%)) drop-shadow(0px 4px 18px rgb(0 0 0 / 12%))",
          }}
        >
          <div className="flex-col-el justify-start w-[510px] relative border-solid border-white border-[8px] rounded-[8px] bg-white">
            <CloseBtn close={handleClose} />

            <div className="flex-col-view justify-start w-full h-full relative p-4 rounded-[4px] bg-beige-60">
              <div className="flex-row-view items-center justify-start flex-wrap py-4">
                <div className="flex-col-center mr-2">
                  <WarningAmberIcon sx={{ fontSize: 40, color: "#FFA03B" }} />
                </div>
                <p className="text-body text-textcolor-black text-[28px]">{title}</p>
              </div>
              <div className="flex-col-view items-start py-4">
                {message?.split("\n").map((line, index) => {
                  return (
                    <div key={index} className="flex-row-view flex-wrap mb-3">
                      <p className="text-body text-textcolor-black leading-[30px] text-[20px]">
                        ・
                      </p>
                      <p className="text-body text-textcolor-black leading-[30px] text-[20px] flex-1">
                        {line}
                      </p>
                    </div>
                  );
                })}
              </div>

              <div className="flex-row-el flex-center w-full gap-6 alpha">
                <button className="btn btn-blue" onClick={handleClose}>
                  <div className="flex-row-center gap-1 mb-[3px]">
                    <span className="material-symbols-outlined !text-4xl">close</span>
                    <p className="text-body text-white text-font-size-body1">
                      {I18n.t("MSG_STOP_BTN")}
                    </p>
                  </div>
                </button>

                <button className="btn btn-danger" onClick={handleClick}>
                  <div className="flex-row-center gap-1 mb-[3px]">
                    <span className="material-symbols-outlined !text-4xl">delete_forever</span>
                    <p className="text-body text-white text-font-size-body1">
                      {I18n.t("MSG_DELETE_BTN")}
                    </p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
